








































































































































































































































































































































































































































































































































































































































































import Component from 'vue-class-component';
import ErpData from '@/components/AccountingSheet/ErpData.vue';
import FormationStatusDrawer from '@/components/AccountingSheet/FormationStatusDrawer.vue';
import SheetEventsDrawer from '@/components/AccountingSheet/SheetEventsDrawer.vue';
import SheetPretensions from '@/components/AccountingSheet/SheetPretensions.vue';
import AccountingSheetController from '@/controllers/AccountingSheet';
import { AccountingSheetInterface, AccountingSheetStatus, CompareDetails } from '@/types/AccountingSheet';
import EntityHelperMixin from '@/mixins/EntityHelperMixin';
import UserMixin from '@/mixins/UserMixin';
import { Mixins } from 'vue-property-decorator';
import DocumentsMixin, { DownloadDocumentsInterface } from '@/mixins/Documents';
import { describeOperationError } from '@/utils/extractApiErrorMessage';
import { resolveSingleLoadOutcome } from '@/utils/accountingSheetAccess';

/** Поставщику zip недоступен; xlsx листа и его собственный файл остаются. */
const SUPPLIER_HIDDEN_DOCUMENT_TYPES = ['sheet_archive'];

@Component({
  components: {
    erpData: ErpData,
    formationStatusDrawer: FormationStatusDrawer,
    sheetEventsDrawer: SheetEventsDrawer,
    sheetPretensions: SheetPretensions,
  },
})
export default class AccountingSheetPage extends Mixins(EntityHelperMixin, UserMixin, DocumentsMixin) {
  headers = [
    {
      text: 'Участок',
      value: 'clientName',
    },
    {
      text: 'ERP ID',
      value: 'clientErpId',
    },
    {
      text: 'Вид услуг',
      value: 'workTypeName',
    },
    {
      text: 'Центр затрат',
      value: 'costCenterName',
    },
    {
      text: 'Счет затрат',
      value: 'costAccount',
    },
    {
      text: 'Выполненный объём',
      value: 'size',
    },
    {
      text: 'ед.измерения',
      value: 'unitName',
    },
    {
      text: 'Производительность, %',
      value: 'performance',
    },
    {
      text: 'Качество, %',
      value: 'quality',
    },
    {
      text: 'Стоимость обратной единицы',
      value: 'tariff',
    },
    {
      text: 'Суммма',
      value: 'totalWithoutTax',
    },
  ];

  cancelDialog = false;

  cancelComment = '';

  recallDialog = false;

  accountingSheet: AccountingSheetInterface | null = null;

  loadingAccountingSheet = false;

  isSendingApprovingRequest = false;

  isSendingCancellingRequest = false;

  isSendingRecallingRequest = false;

  isSendingStatusRequest = false;

  acceptChangesDialog = false;

  acceptChangesComment = '';

  rejectChangesDialog = false;

  rejectChangesComment = '';

  isSendingSupplierChangesRequest = false;

  packageRejectDialog = false;

  packageRejectComment = '';

  isSendingPackageRejectRequest = false;

  packageUnblockDialog = false;

  isSendingPackageUnblockRequest = false;

  isSendingUnblockRequest = false;

  /** Файлы поставщика (objectName), у которых таблицу расхождений переключили против умолчания. */
  compareDetailsToggled: string[] = [];

  /**
   * Со встречи 16.09.2026 решение по изменённому листу принимает Светлана Терсинских,
   * а не любые кадры и контроллинг. Круг решающих задан списком в настройке коннектора
   * статусов; карточка списка не знает и спрашивает у него право — чтобы показать
   * кнопки неактивными, а не прятать их. По умолчанию true: не ответил коннектор —
   * кнопки остаются живыми, отказ всё равно придёт с бэка.
   */
  canDecideSupplierChanges = true;

  readonly supplierChangesDeciderHint = 'Решение принимает Светлана Терсинских, доступ откроется после обучения';

  selectedStatus = AccountingSheetStatus.SUPPLIER_CONFIRMATION_AWAIT;

  async beforeMount() {
    await this.loadAccountingSheet();
    await this.loadSupplierChangesPermission();
  }

  get isStatusAllowToCancel(): boolean {
    const allowedStatuses = [
      AccountingSheetStatus.CREATED,
      AccountingSheetStatus.SUPPLIER_CONFIRMATION_AWAIT,
      AccountingSheetStatus.SUPPLIER_CHANGES_APPROVAL,
      AccountingSheetStatus.CONTROLLING_APPROVAL_AWAIT,
      AccountingSheetStatus.DIADOC_SIGNING_AWAIT,
      // Документооборот в Диадоке может застрять навсегда: поставщик аннулирует
      // комплект, и архива с подписями обеих сторон уже не будет. Без отмены
      // лист заперт — ни сменить статус, ни поправить реквизиты.
      AccountingSheetStatus.SIGNED_BY_SIGNER,
      AccountingSheetStatus.ACCOUNTANT_APPROVAL_AWAIT,
    ];
    return this.accountingSheet !== null && allowedStatuses.includes(this.accountingSheet.status);
  }

  /**
   * Комплект документов с ошибкой отклоняют бухгалтерия, кадры и контроллинг — на этапах,
   * где комплект уже принят, а оплата ещё не согласована (11995). Лист возвращается
   * ждать от поставщика новый комплект.
   */
  get isPackageRejectAllowed(): boolean {
    const allowedStatuses = [
      AccountingSheetStatus.CONTROLLING_APPROVAL_AWAIT,
      AccountingSheetStatus.DIADOC_SIGNING_AWAIT,
      AccountingSheetStatus.SIGNED_BY_SIGNER,
      AccountingSheetStatus.ACCOUNTANT_APPROVAL_AWAIT,
    ];
    return this.accountingSheet !== null
      && allowedStatuses.includes(this.accountingSheet.status)
      && (this.isAccountant || this.isHR || this.isControlling);
  }

  /**
   * Отклонение комплекта отменяют те же роли, пока лист ждёт архив или стоит в «Возникла
   * проблема» (12937): после отмены опрос снова берёт архив, который поставщик уже прислал.
   */
  get isPackageUnblockAllowed(): boolean {
    const allowedStatuses = [
      AccountingSheetStatus.SUPPLIER_CONFIRMATION_AWAIT,
      AccountingSheetStatus.PROBLEM,
    ];
    return this.accountingSheet !== null
      && allowedStatuses.includes(this.accountingSheet.status)
      && (this.accountingSheet.rejectedPackages || []).length > 0
      && (this.isAccountant || this.isHR || this.isControlling);
  }

  /**
   * В блоке согласия «Отменить» стоит рядом с «Не согласен», и разница между ними
   * не в том, куда уйдёт лист, а в письме поставщику и черном списке (10857, П3).
   * В остальных статусах кнопка прежняя.
   */
  get cancelButtonName(): string {
    return this.isSupplierChangesAction ? 'Отменить без письма' : 'Отменить';
  }

  get cancelDialogTitle(): string {
    return this.isSupplierChangesAction
      ? 'Отменить согласование "Листа учета"?'
      : 'Вы действительно хотите отменить "Лист учета"?';
  }

  get isControllingAction(): boolean {
    return this.accountingSheet !== null && this.accountingSheet.status === AccountingSheetStatus.CONTROLLING_APPROVAL_AWAIT && this.isControlling;
  }

  get isAccountantAction(): boolean {
    return this.accountingSheet !== null && this.accountingSheet.status === AccountingSheetStatus.ACCOUNTANT_APPROVAL_AWAIT && this.isAccountant;
  }

  get isAccountantPaymentAction(): boolean {
    return this.accountingSheet !== null && this.accountingSheet.status === AccountingSheetStatus.PAYMENT_AWAIT && this.isAccountant;
  }

  get isSignerAction(): boolean {
    return this.accountingSheet !== null && this.accountingSheet.status === AccountingSheetStatus.DIADOC_SIGNING_AWAIT && this.isSigner;
  }

  /** С изменённым файлом поставщика соглашаются или отказываются кадры и контроллинг. */
  get isSupplierChangesAction(): boolean {
    return this.accountingSheet !== null
      && this.accountingSheet.status === AccountingSheetStatus.SUPPLIER_CHANGES_APPROVAL
      && (this.isHR || this.isControlling);
  }

  /** Таблицы расхождений под плитками — в порядке плиток. */
  get openedCompareDetails(): DownloadDocumentsInterface[] {
    return this.downloadDocuments.filter((item) => this.hasCompareDetails(item) && this.isCompareDetailsOpen(item));
  }

  get showErpData(): boolean {
    return !this.isSupplier;
  }

  // Координатору раздел претензий закрыт — и претензии листа тоже.
  get showSheetPretensions(): boolean {
    return !this.isCoordinator;
  }

  get showSheetActions(): boolean {
    return !this.isSupplier;
  }

  /** sheet-events поставщику и так отвечает 403. */
  get showStatusDrawers(): boolean {
    return !this.isSupplier;
  }

  get isAvailableButton(): boolean {
    return this.isControllingAction || this.isAccountantAction || this.isAccountantPaymentAction || this.isSignerAction;
  }

  get isProblem(): boolean {
    return this.accountingSheet !== null && this.accountingSheet.status === AccountingSheetStatus.PROBLEM && this.isHR;
  }

  get showComment(): boolean {
    return this.accountingSheet !== null
      && this.accountingSheet.comment !== null
      && this.accountingSheet.comment !== ''
      && (
        this.accountingSheet.status === AccountingSheetStatus.PROBLEM
        || this.accountingSheet.status === AccountingSheetStatus.RECALLED
      );
  }

  get btnName(): string {
    if (this.isControllingAction) {
      return 'Отправить на подпись';
    }
    if (this.isAccountantAction) {
      return 'Отправить в ERP';
    }
    if (this.isAccountantPaymentAction) {
      return 'Отправить в оплачено';
    }
    if (this.isSignerAction) {
      return 'Подписать';
    }
    return 'Отправить дальше';
  }

  get availableChangeStatuses(): string[] {
    return [
      AccountingSheetStatus.SUPPLIER_CONFIRMATION_AWAIT,
      AccountingSheetStatus.CONTROLLING_APPROVAL_AWAIT,
      AccountingSheetStatus.DIADOC_SIGNING_AWAIT,
      AccountingSheetStatus.ACCOUNTANT_APPROVAL_AWAIT,
      AccountingSheetStatus.PAYMENT_AWAIT,
      AccountingSheetStatus.PAYMENT_DONE,
    ];
  }

  onError(error: any): void {
    this.$bus.$emit('notification', `Возникла ошибка при выполнении операции: ${describeOperationError(error)}`, 'error');
    console.error(error);
  }

  onSuccess(result: any): void {
    console.log('Result after request - ', result);
    this.$bus.$emit('notification', 'Операция успешно выполнена', 'success');
    this.loadAccountingSheet();
  }

  async onSubmitApprovingSheet(): Promise<void> {
    if (this.isControllingAction) {
      this.onSubmitApproveByControlling();
    } else if (this.isAccountantAction) {
      this.onSubmitApproveByAccountant();
    } else if (this.isAccountantPaymentAction) {
      this.onSubmitPaymentDoneByAccountant();
    } else if (this.isSignerAction) {
      this.onSubmitSignBySigner();
    } else {
      this.$bus.$emit('notification', 'У вас нет прав для выполнения операций с листом учета', 'warning');
    }
  }

  async onSubmitChangeStatus(): Promise<void> {
    try {
      if (!this.accountingSheet) {
        throw new Error("Accounting sheet doesn't exist");
      }
      this.isSendingStatusRequest = true;
      const response = await AccountingSheetController.statusChange(this.accountingSheet.id, this.selectedStatus);
      const [error, result] = response.result;
      if (error) this.onError(error);
      else this.onSuccess(result);
    } catch (error) {
      this.onError(error);
    } finally {
      this.isSendingStatusRequest = false;
    }
  }

  async onSubmitApproveByControlling(): Promise<void> {
    try {
      if (!this.accountingSheet) {
        throw new Error("Accounting sheet doesn't exist");
      }
      this.isSendingApprovingRequest = true;
      const response = await AccountingSheetController.statusApproveByControlling(this.accountingSheet.id);
      const [error, result] = response.result;
      if (error) this.onError(error);
      else this.onSuccess(result);
    } catch (error) {
      this.onError(error);
    } finally {
      this.isSendingApprovingRequest = false;
    }
  }

  async onSubmitPaymentDoneByAccountant(): Promise<void> {
    try {
      if (!this.accountingSheet) {
        throw new Error("Accounting sheet doesn't exist");
      }
      this.isSendingApprovingRequest = true;
      const response = await AccountingSheetController.statusPaymentDoneByAccountant(this.accountingSheet.id);
      const [error, result] = response.result;
      if (error) this.onError(error);
      else this.onSuccess(result);
    } catch (error) {
      this.onError(error);
    } finally {
      this.isSendingApprovingRequest = false;
    }
  }

  async onSubmitApproveByAccountant(): Promise<void> {
    try {
      if (!this.accountingSheet) {
        throw new Error("Accounting sheet doesn't exist");
      }
      (this.$refs.erpData as any).$v.$touch();
      if ((this.$refs.erpData as any).$v.$invalid) {
        this.$bus.$emit('notification', 'Пожалуйста, заполните данные для ERP', 'warning');
        return;
      }

      this.isSendingApprovingRequest = true;

      const isUpdatederpData: boolean = await (this.$refs.erpData as any).onSubmit(true);
      if (!isUpdatederpData) return;
      const response = await AccountingSheetController.statusApproveByAccountant(this.accountingSheet.id);

      const [error, result] = response.result;
      if (error) this.onError(error);
      else this.onSuccess(result);
    } catch (error) {
      this.onError(error);
    } finally {
      this.isSendingApprovingRequest = false;
    }
  }

  async onSubmitSignBySigner(): Promise<void> {
    try {
      if (!this.accountingSheet) {
        throw new Error("Accounting sheet doesn't exist");
      }
      this.isSendingApprovingRequest = true;

      const [error, result] = (await AccountingSheetController.sign(this.accountingSheet.id)).result;
      if (error) this.onError(error);
      else this.onSuccess(result);
    } catch (error) {
      this.onError(error);
    } finally {
      this.isSendingApprovingRequest = false;
    }
  }

  async cancelAccountingSheet(): Promise<void> {
    this.cancelDialog = false;
    try {
      if (!this.accountingSheet) {
        throw new Error("Accounting sheet doesn't exist");
      }
      if (!this.isStatusAllowToCancel) {
        throw new Error("Status of the accounting sheet doesn't allow you to change it");
      }

      this.isSendingCancellingRequest = true;
      const response = await AccountingSheetController.cancel(this.accountingSheet.id, this.cancelComment);
      const [error, result] = response.result;
      if (error) this.onError(error);
      else this.onSuccess(result);
    } catch (error) {
      this.onError(error);
    } finally {
      this.isSendingCancellingRequest = false;
    }
  }

  /**
   * Расхождения файла поставщика видит каждый, кому видна лента обработки; списком решающих
   * не ограничено. Записи расхождений нет — нет и пункта меню.
   */
  hasCompareDetails(item: Pick<DownloadDocumentsInterface, 'documentType' | 'compareDetails'>): boolean {
    return item.documentType === 'sheet_supplier'
      && item.compareDetails !== null
      && !this.isSupplier
      && !this.isGuest;
  }

  /**
   * В статусе согласия таблица файла, ждущего решения, открыта сразу; остальные — по меню.
   * Нажатие в меню переключает таблицу против этого умолчания.
   */
  isCompareDetailsOpen(item: Pick<DownloadDocumentsInterface, 'objectName' | 'compareResult' | 'rejectedAt'>): boolean {
    const pending = this.accountingSheet !== null
      && this.accountingSheet.status === AccountingSheetStatus.SUPPLIER_CHANGES_APPROVAL
      && item.compareResult === 'differs'
      && !item.rejectedAt;
    return pending !== this.compareDetailsToggled.includes(item.objectName);
  }

  toggleCompareDetails(item: Pick<DownloadDocumentsInterface, 'objectName'>): void {
    this.compareDetailsToggled = this.compareDetailsToggled.includes(item.objectName)
      ? this.compareDetailsToggled.filter((objectName) => objectName !== item.objectName)
      : [...this.compareDetailsToggled, item.objectName];
  }

  /** Коннектор архива кладёт в карточку первые 50 ячеек; остальные — одной строкой. */
  hiddenChangesText(details: CompareDetails): string {
    const hidden = (details.cellCount ?? details.cells.length) - details.cells.length;
    if (hidden <= 0) {
      return '';
    }
    const [last, lastTwo] = [hidden % 10, hidden % 100];
    let noun = 'изменений';
    if (last === 1 && lastTwo !== 11) {
      noun = 'изменение';
    } else if (last >= 2 && last <= 4 && (lastTwo < 12 || lastTwo > 14)) {
      noun = 'изменения';
    }
    return `и ещё ${hidden} ${noun}`;
  }

  /** Дата приёма из ключа файла поставщика: documents/{ИНН}/гггг/мм/дд/{хеш}/{файл}. */
  receivedOn(objectName: string): string {
    const match = /\/(\d{4})\/(\d{2})\/(\d{2})\/[^/]+\/[^/]+$/.exec(objectName);
    return match ? ` от ${match[3]}.${match[2]}.${match[1]}` : '';
  }

  /**
   * Отказ снимают, пока лист ждёт архив или стоит в «Возникла проблема»: позже отметка
   * ни на что не влияет. Меню — у отклонённого листа поставщика, у zip его нет.
   */
  canUnblockDocument(item: { documentType: string | null; rejectedAt: string | null }): boolean {
    return item.documentType === 'sheet_supplier'
      && Boolean(item.rejectedAt)
      && (this.isHR || this.isControlling)
      && this.accountingSheet !== null
      && [
        AccountingSheetStatus.SUPPLIER_CONFIRMATION_AWAIT,
        AccountingSheetStatus.PROBLEM,
      ].includes(this.accountingSheet.status);
  }

  /** Право на решение по изменённому листу — см. canDecideSupplierChanges. */
  async loadSupplierChangesPermission(): Promise<void> {
    if (!this.isHR && !this.isControlling) {
      return;
    }
    try {
      const response = await AccountingSheetController.supplierChangesPermission();
      const [error, result] = response.result;
      if (error) {
        console.error(error);
        return;
      }
      this.canDecideSupplierChanges = result?.result?.canDecide !== false;
    } catch (error) {
      console.error(error);
    }
  }

  async acceptSupplierChanges(): Promise<void> {
    this.acceptChangesDialog = false;
    try {
      if (!this.accountingSheet) {
        throw new Error("Accounting sheet doesn't exist");
      }
      this.isSendingSupplierChangesRequest = true;
      const response = await AccountingSheetController.supplierChangesAccept(this.accountingSheet.id, this.acceptChangesComment.trim());
      const [error, result] = response.result;
      if (error) this.onError(error);
      else {
        this.acceptChangesComment = '';
        this.onSuccess(result);
      }
    } catch (error) {
      this.onError(error);
    } finally {
      this.isSendingSupplierChangesRequest = false;
    }
  }

  async rejectSupplierChanges(): Promise<void> {
    this.rejectChangesDialog = false;
    try {
      if (!this.accountingSheet) {
        throw new Error("Accounting sheet doesn't exist");
      }
      this.isSendingSupplierChangesRequest = true;
      const response = await AccountingSheetController.supplierChangesReject(this.accountingSheet.id, this.rejectChangesComment.trim());
      const [error, result] = response.result;
      if (error) this.onError(error);
      else {
        this.rejectChangesComment = '';
        this.onSuccess(result);
      }
    } catch (error) {
      this.onError(error);
    } finally {
      this.isSendingSupplierChangesRequest = false;
    }
  }

  /**
   * При ошибке диалог остаётся открытым, а лист не перечитывается: возврат листа — два шага,
   * и на сбое второго коннектор просит нажать «Отклонить» ещё раз. Перечитанный лист стоял бы
   * уже в «Возникла проблема», где этой кнопки нет.
   */
  async rejectPackage(): Promise<void> {
    try {
      if (!this.accountingSheet) {
        throw new Error("Accounting sheet doesn't exist");
      }
      this.isSendingPackageRejectRequest = true;
      const response = await AccountingSheetController.packageReject(this.accountingSheet.id, this.packageRejectComment.trim());
      const [error, result] = response.result;
      if (error) this.onError(error);
      else {
        this.packageRejectDialog = false;
        this.packageRejectComment = '';
        this.onSuccess(result);
      }
    } catch (error) {
      this.onError(error);
    } finally {
      this.isSendingPackageRejectRequest = false;
    }
  }

  async unblockPackage(): Promise<void> {
    this.packageUnblockDialog = false;
    try {
      if (!this.accountingSheet) {
        throw new Error("Accounting sheet doesn't exist");
      }
      this.isSendingPackageUnblockRequest = true;
      const response = await AccountingSheetController.packageUnblock(this.accountingSheet.id);
      const [error, result] = response.result;
      if (error) this.onError(error);
      else this.onSuccess(result);
    } catch (error) {
      this.onError(error);
    } finally {
      this.isSendingPackageUnblockRequest = false;
    }
  }

  async unblockSupplierSheet(item: { objectName: string }): Promise<void> {
    try {
      if (!this.accountingSheet) {
        throw new Error("Accounting sheet doesn't exist");
      }
      this.isSendingUnblockRequest = true;
      const response = await AccountingSheetController.supplierChangesUnblock(this.accountingSheet.id, item.objectName);
      const [error, result] = response.result;
      if (error) this.onError(error);
      else this.onSuccess(result);
    } catch (error) {
      this.onError(error);
    } finally {
      this.isSendingUnblockRequest = false;
    }
  }

  async recallAccountingSheet(): Promise<void> {
    this.recallDialog = false;
    try {
      if (!this.accountingSheet) {
        throw new Error("Accounting sheet doesn't exist");
      }
      if (!this.isProblem) {
        throw new Error("Status of the accounting sheet doesn't allow you to recall it");
      }

      this.isSendingRecallingRequest = true;
      const response = await AccountingSheetController.recall(this.accountingSheet.id);
      const [error, result] = response.result;
      if (error) this.onError(error);
      else this.onSuccess(result);
    } catch (error) {
      this.onError(error);
    } finally {
      this.isSendingRecallingRequest = false;
    }
  }

  async loadAccountingSheet() {
    const requestedId = Number(this.$route?.params?.id);
    if (!requestedId) {
      return null;
    }
    this.loadingAccountingSheet = true;
    try {
      const response = await AccountingSheetController.loadSingle(requestedId);
      const [error, result] = response.result;
      const receivedId = typeof result?.data?.id === 'number' ? result.data.id : null;
      const outcome = resolveSingleLoadOutcome({
        isSupplier: this.isSupplier,
        code: response.code,
        hasError: Boolean(error),
        requestedId,
        receivedId,
      });

      if (outcome === 'access-denied') {
        console.error(`[loadAccountingSheet] доступ запрещён: requested=${requestedId}, received=${receivedId}, code=${response.code}`);
        this.$router.replace({ name: 'AccessDenied' });
        return null;
      }

      if (outcome === 'error') {
        this.$bus.$emit('notification', 'Возникла ошибка при получении листа учета, попробуйте позже', 'error');
        console.error(error ?? `[loadAccountingSheet] requested=${requestedId}, received=${receivedId}`);
        return null;
      }

      this.accountingSheet = result.data;
      this.makeDocumentsLinks(
        result.data,
        this.isSupplier ? { excludeTypes: SUPPLIER_HIDDEN_DOCUMENT_TYPES } : undefined,
      );
      this.formatMonetaryFields(result.data);
      return result.data;
    } catch (e) {
      console.error(e);
      return null;
    } finally {
      this.loadingAccountingSheet = false;
    }
  }

  async loadWorkTypeById(ids: number[]) {
    try {
      const filter = {
        $or: ids.map((id) => ({ oo_id: { $like: String(id) } })),
      };
      const workType = await this.loadEntityListing('Work', { filter: JSON.stringify(filter) }, 'network-only');
      if (workType?.length) {
        return workType;
      }
      return [];
    } catch (e) {
      console.error(e);
      return [];
    }
  }

  protected formatMonetaryFields(object: AccountingSheetInterface) {
    object.groups.forEach((item) => {
      Object.assign(item, {
        tariff: this.$n(item.tariff, 'decimal'),
        totalWithoutTax: this.$n(item.totalWithoutTax, 'decimal'),
      });
    });
  }
}
